import { render, staticRenderFns } from "./ModalCont.vue?vue&type=template&id=f54c3280"
import script from "./ModalCont.vue?vue&type=script&lang=js"
export * from "./ModalCont.vue?vue&type=script&lang=js"
import style0 from "./ModalCont.vue?vue&type=style&index=0&id=f54c3280&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports